import { PACKAGE_PERMISSIONS } from '@/constants/features'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'
import store from '@/store'

export default [
  {
    title: 'navigation.reports',
    svgIcon: 'icon-reports',
    children: [
      {
        title: 'navigation.gain-and-loss',
        svgIcon: 'icon-gain-and-loss',
        route: 'admin:reports:gain-and-loss',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_GAIN_AND_LOSS_VIEW,
      },
      {
        title: 'navigation.sales-per',
        route: 'admin:reports:sales-per',
        svgIcon: 'icon-sales-per-items',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_PER_VIEW,
      },
      {
        title: 'navigation.items-orders-report',
        svgIcon: 'icon-order-line-report',
        route: 'admin:reports:order-lines',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_ORDER_LINES_VIEW,
      },
      {
        title: 'pos.sales-report',
        route: 'admin:reports:custom-report',
        svgIcon: 'icon-order-line-report',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_SALES_VIEW,
      },
      {
        title: 'navigation.order-details',
        svgIcon: 'icon-order-details',
        route: 'admin:reports:order-details',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_ORDERS_VIEW,
      },
      {
        title: 'navigation.transferable-orders-report',
        svgIcon: 'icon-order-details',
        route: 'admin:reports:transferable-orders',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_TRANSFERABLE_ORDERS_VIEW,
      },
      // {
      //   title: 'navigation.b2b-reports',
      //   svgIcon: 'icon-order-details',
      //   route: 'admin:reports:b2b',
      //   permission: [
      //     SUBUSER_PERMISSION_SLUGS.REPORTS_ORDERS_VIEW,
      //     SUBUSER_PERMISSION_SLUGS.B2B_VIEW,
      //   ],
      //   hide: () => !store.getters['subscription/isB2bPurchased'],
      // },
      // {
      //   title: 'statistics.statistics',
      //   tag: 'upgrade',
      //   tagPackagePermission: PACKAGE_PERMISSIONS.STATISTICS,
      //   route: 'admin:statistics',
      //   svgIcon: 'icon-statistics',
      //   permission: SUBUSER_PERMISSION_SLUGS.REPORTS_STATISTICS_VIEW,
      // },
      {
        title: 'navigation.branches-statistics',
        tag: 'upgrade',
        tagPackagePermission: PACKAGE_PERMISSIONS.STATISTICS,
        route: 'admin:branches-statistics',
        svgIcon: 'icon-branches-statistics',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_BRANCHES_STATISTICS_VIEW,
      },
    ],
  },

]
